import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
const navigate = useNavigate();
  const studentName = sessionStorage.getItem("clientName");
  useEffect(() => {
    const countdown = () => {
      const countDate = new Date('Jun 30, 2026 00:00:00').getTime(); // Updated to 2026
      const now = new Date().getTime();
      const gap = countDate - now;

      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      const days = Math.floor(gap / day);
      const hours = Math.floor((gap % day) / hour);
      const minutes = Math.floor((gap % hour) / minute);
      const seconds = Math.floor((gap % minute) / second);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    const timerId = setInterval(countdown, 1000);
    return () => clearInterval(timerId);
  }, []);

  const styles = {
    body: {
      height: '100vh',
      margin: 0,
      fontFamily: "'Segoe UI', 'Roboto', 'Arial', sans-serif",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      background: 'linear-gradient(135deg, rgba(69,150,164,1) 0%, rgba(17,20,34,1) 100%)',
      color: 'white',
      padding: '20px',
    },
    container: {
      maxWidth: '800px',
      width: '100%',
      padding: '40px',
      background: 'rgba(0, 0, 0, 0.5)',
      borderRadius: '16px',
      marginBottom: '20px',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    },
    greeting: {
      fontSize: '1.5em',
      marginBottom: '10px',
      fontWeight: '300',
      opacity: '0.9',
    },
    h1: {
      fontSize: '3.5em',
      marginBottom: '10px',
      fontWeight: '700',
      letterSpacing: '1px',
    },
    p: {
      fontSize: '1.2em',
      margin: '20px 0',
      opacity: '0.9',
      lineHeight: '1.6',
    },
    countdown: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      margin: '30px 0',
      flexWrap: 'wrap',
    },
    countdownItem: {
      background: 'rgba(255, 255, 255, 0.1)',
      padding: '20px',
      borderRadius: '12px',
      minWidth: '100px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    },
    countdownValue: {
      fontSize: '2.5em',
      fontWeight: 'bold',
      display: 'block',
    },
    countdownLabel: {
      fontSize: '0.9em',
      opacity: '0.8',
      marginTop: '5px',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    button: {
      padding: '12px 30px',
      fontSize: '1.1em',
      color: '#fff',
      background: 'linear-gradient(111.1deg, rgba(69,150,164,1) 2.5%, rgba(17,20,34,1) 100.3%)',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      textDecoration: 'none',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.3)',
        background: 'linear-gradient(111.1deg, rgba(69,150,164,0.9) 2.5%, rgba(17,20,34,0.9) 100.3%)',
      },
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <p style={styles.greeting}>Hello, {studentName.replace(/['"]+/g, "")}!</p>
        <h1 style={styles.h1}>Coming Soon</h1>
        <p style={styles.p}>
          We are working hard to bring you an amazing experience. Stay tuned for updates.
        </p>
        <div style={styles.countdown}>
          <div style={styles.countdownItem}>
            <span style={styles.countdownValue}>{timeLeft.days}</span>
            <span style={styles.countdownLabel}>Days</span>
          </div>
          <div style={styles.countdownItem}>
            <span style={styles.countdownValue}>{timeLeft.hours}</span>
            <span style={styles.countdownLabel}>Hours</span>
          </div>
          <div style={styles.countdownItem}>
            <span style={styles.countdownValue}>{timeLeft.minutes}</span>
            <span style={styles.countdownLabel}>Minutes</span>
          </div>
          <div style={styles.countdownItem}>
            <span style={styles.countdownValue}>{timeLeft.seconds}</span>
            <span style={styles.countdownLabel}>Seconds</span>
          </div>
        </div>
      </div>
      <button
        style={styles.button}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.3)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
        }}
        onClick={()=> navigate("/studentDashboard")}
      >
        Go To Dashboard
      </button>
    </div>
  );
};

export default ComingSoon;
